import React from "react";
import Topbar from "../components/Topbar";
import Navbar from "../components/Navbar";
import Partners from "../components/Partners_logo";
import Careers from "../components/Careers";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Banner from "../components/AboutBanner"
import Aboutindustrial from "../components/About/About-industrial";
import ExperienceSection from "../components/About/ExperienceSection";
import ProgramsSection from "../components/About/ProgramsSection";
import TeamMembers from "../components/About/TeamMembers";
import FactorySection from "../components/About/FactorySection";
import TeamSection from "../components/About/TeamSection";
import StatsSection from "../components/StatsSection";


const Home = () => {
  return (
    <main className="homepage">
      <Topbar />
      <Navbar />
      <Banner />
      <Aboutindustrial />
      <ExperienceSection />
      <Partners />
      {/* <ProgramsSection /> */}
      {/* <FactorySection /> */}
      <TeamSection />
      <TeamMembers />
      <StatsSection />            
      <Careers />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
